import { ErrorHandler, Injectable } from '@angular/core';
import { NeoLogService } from '@app/services/neo-log.service';
import { OtelService } from '@app/services/otel.service';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';

@Injectable()
export class NeoGlobalErrorHandler extends ApplicationinsightsAngularpluginErrorService implements ErrorHandler {

  constructor(private neoLogService: NeoLogService, private otelService: OtelService) {
    super();
  }

  public handleError(error: unknown): void {
    this.neoLogService.error('NeoGlobalErrorHandler->handleError', error);
    this.otelService.recordException(error);
    super.handleError(error);
  }
}